import { IconCycleArrows } from '../../../../../../assets/DesignSystem/SVGComponents';
import { IlogisticServiceTrelloCardData, LOGISTIC_SERVICE_STATUS_NAME } from '../../../../../../types/services';
import { formatShortDate } from '../../../../../../utils/formatDatesAndHours';
import './LsTrelloCardUpperRightInformation.scss';

const LsTrelloCardUpperRightInformation = ({
  logisticServiceData,
  specialNotifications,
  openDelayedModalCallback
}: {
  logisticServiceData: IlogisticServiceTrelloCardData;
  specialNotifications?: IlogisticServiceTrelloCardSpecialNotifications;
  openDelayedModalCallback?: () => void;
}) => {
  const { dates, hasUpdatedDates = false, isLate, status } = logisticServiceData || {};
  const { requestDate, confirmedDate, programmedDate, deliveryDate, cancelledDate, inProcessDate } = dates || {};
  const { missingDns, isDelayed, pendingConfigurations } = specialNotifications || {};

  const isDelivered = status === LOGISTIC_SERVICE_STATUS_NAME.DELIVERED;

  const getUpperRightDisplayData: () => ILsTrelloCardUpperRightNotificationDisplayData = () => {
    const delayedText = `${hasUpdatedDates ? 'Actualizado' : 'Programado para'}: ${
      formatShortDate(programmedDate || '')?.onlyDate || '-'
    }`;
    const delayedData = {
      text: delayedText,
      icon: <IconCycleArrows className="IconCycleArrows" />,
      className: 'isDelayed',
      onClick: openDelayedModalCallback
    };
    const pendingConfigurationsData = {
      text: 'Configuraciones incompletas ⚠️',
      className: isDelivered ? 'pendingConfigurationAlert' : ''
    };

    if (cancelledDate)
      return { text: `cancelado: ${formatShortDate(cancelledDate || '')?.onlyDate || '-'}`, icon: <></> };
    if (isDelivered && pendingConfigurations) return pendingConfigurationsData;
    if (missingDns)
      return {
        text: 'Falta DNS ⚠️',
        className: 'missingDnsAlert'
      };
    if (deliveryDate)
      return { text: `entregado: ${formatShortDate(deliveryDate || '')?.onlyDate || '-'}`, icon: <></> };
    if (isDelayed && isLate) return delayedData;
    if (pendingConfigurations) return pendingConfigurationsData;
    if (isDelayed && !isLate) return delayedData;
    if (programmedDate)
      return { text: `programado: ${formatShortDate(programmedDate || '')?.onlyDate || '-'}`, icon: <></> };
    if (inProcessDate) {
      return { text: `en proceso: ${formatShortDate(inProcessDate || '')?.onlyDate}`, icon: <></> };
    }
    if (confirmedDate)
      return { text: `confirmado: ${formatShortDate(confirmedDate || '')?.onlyDate || '-'}`, icon: <></> };
    if (requestDate) return { text: `solicitado: ${formatShortDate(requestDate || '')?.onlyDate || '-'}`, icon: <></> };
    return {};
  };

  const dataToDisplay = getUpperRightDisplayData();

  return (
    <div className="lsTrelloCardUpperRightInformation">
      <div className="logisticServiceRelevantDate" onClick={dataToDisplay?.onClick}>
        <div className={dataToDisplay?.className || ''}>{dataToDisplay?.text}</div>
        {dataToDisplay?.icon}
      </div>
    </div>
  );
};

export default LsTrelloCardUpperRightInformation;

export interface IlogisticServiceTrelloCardSpecialNotifications {
  missingDns?: boolean | null;
  isDelayed?: boolean | null;
  pendingConfigurations?: boolean | null;
}

export interface ILsTrelloCardUpperRightNotificationDisplayData {
  text?: string | null;
  icon?: JSX.Element;
  className?: string | null;
  onClick?: () => void;
}
